import { Component, Input, OnInit } from '@angular/core';
import { ProjectService } from 'src/app/open-age/gateway/services/project.service';
import { UxService } from '~/app/core/services';
import { ProjectDetailBaseComponent } from '~/app/open-age/gateway/components/project-detail.base.component';
import { SprintService, TaskService } from '~/app/open-age/gateway/services';

@Component({
  selector: 'gateway-project-summary',
  templateUrl: './project-summary.component.html',
  styleUrls: ['./project-summary.component.css']
})
export class ProjectSummaryComponent extends ProjectDetailBaseComponent {

  constructor(
    service: ProjectService,
    sprintService: SprintService,
    storyService: TaskService,
    uxService: UxService
  ) {
    super(service, sprintService, storyService, uxService);
  }

}
